<script setup lang="ts">
// Presentational only — no store, no onMounted, no injection — so this
// mounts with a plain @vue/test-utils `mount()` and the existing
// `tests/setup.ts` stubs, unlike its consumer (Close.vue), whose onMounted
// cascade (createShiftStore -> fetchEmployees/fetchOpenShift/getAllShiftData,
// dialogRef injection) has no test harness in this repo. The three-way
// mapping from CashWarning to copy lives here so it can be pinned directly:
// see components/Shift/__tests__/CashWarning.test.ts.
//
// Uses `useNuxtApp().$i18n` (not `useI18n()`, the convention in the rest of
// this directory) to match how Close.vue — the only consumer — already
// reads i18n, and because that is the pattern `tests/setup.ts` already stubs.
import type { CashWarning } from '~/utils/shiftCash'

withDefaults(defineProps<{
  warning: CashWarning
  unclassifiedCount?: number
}>(), {
  unclassifiedCount: 0,
})

const { t } = useNuxtApp().$i18n
</script>

<template>
  <p
    v-if="warning === 'methodMissing'"
    class="text-xs text-amber-700 bg-amber-50 rounded px-3 py-2 mt-2"
  >
    {{ t('shift.cash.noCashMethodConfigured') }}
  </p>
  <p
    v-else-if="warning === 'unclassifiedMethods'"
    class="text-xs text-amber-700 bg-amber-50 rounded px-3 py-2 mt-2"
  >
    {{ t('shift.cash.unclassifiedMethods', { count: unclassifiedCount }) }}
  </p>
</template>
